import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core';
import Snackbar from '@material-ui/core/Snackbar';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';

const styles = () => ({
  success: {
    backgroundColor: '#43a047',
  },
  message: {
    display: 'flex',
    alignItems: 'center',
  }
});

class Message extends React.Component {
  static propTypes = {
    message: PropTypes.string.isRequired,
    isOpen: PropTypes.bool.isRequired,
    close: PropTypes.func.isRequired
  };

  render() {
    const { classes, message, isOpen, close } = this.props;

    return (
      <Snackbar
        className={classes.success}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        open={isOpen}
        autoHideDuration={6000}
        onClose={() => this.handleClose}
        ContentProps={{
          'aria-describedby': 'message-id',
          classes: {
            root: classes.success
          }
        }}
        message={<span id="message-id" className={classes.message}
        >
          <CheckCircleIcon key='done' />
          {message}
        </span>}
        action={[
          <IconButton
            key="close"
            aria-label="Close"
            color="inherit"
            className={classes.close}
            onClick={close}
          >
            <CloseIcon />
          </IconButton>,
        ]}
      />
    )
  }
}

export default withStyles(styles)(Message);